
import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import * as subscriptionActions from '../../actions/subscriptionActions';
import {
    Grid,
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel,
    Image
} from "react-bootstrap";
//import "react-select/dist/react-select.css";
import Card from "../../components/Card/Card.jsx";
import Datetime from "react-datetime";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from "../../components/CustomButton/CustomButton.jsx";
import rest from "../../API/api";
import ReactDOM from "react-dom";
import {addTenantsSuccess} from "../../actions/tenantActions";
import {updateKioskusersSuccess} from "../../actions/kioskuserActions";

class SubscriptionForm extends Component {
    constructor(props) {
        super(props);
        this._grabUserInput = this._grabUserInput.bind(this);
        this._readSubscription = this._readSubscription.bind(this);
        this._processSubscriptionEvent = this._processSubscriptionEvent.bind(this);
        this._warningWithConfirmMessage = this._warningWithConfirmMessage.bind(this);
        this._hideAlert = this._hideAlert.bind(this);
        this.state = {
            RequestingTenantId: this.props.subscription.RequestingTenantId,
            EventType: this.props.subscription.EventType,
            Userid: this.props.subscription.Userid,
            Kioskid: this.props.subscription.Kioskid,
            Email:  this.props.subscription.Email,
            Company: this.props.subscription.Company,
            Fname: this.props.subscription.Fname,
            Lname: this.props.subscription.Lname,
            Address: this.props.subscription.Address,
            City: this.props.subscription.City,
            State: this.props.subscription.State,
            Country: this.props.subscription.Country,
            Postal: this.props.subscription.Postal,
            Phone: this.props.subscription.Phone,
            SubscriptionDate: this.props.subscription.SubscriptionDate,
            SubscriptionStatus: this.props.subscription.SubscriptionStatus,
            SubscriptionType: this.props.subscription.SubscriptionType,
            SubscriptionPrice: this.props.subscription.SubscriptionPrice,
            SubscriptionMultiShopCount: this.props.subscription.SubscriptionMultiShopCount,
            CustomerXRef: this.props.subscription.CustomerXRef,
            UserHash: this.props.subscription.UserHash,
            UserSalt: this.props.subscription.UserSalt,
            KioskHash: this.props.subscription.KioskHash,
            KioskSalt: this.props.subscription.KioskSalt,
            CCNumber: this.props.subscription.CCNumber,
            CCName: this.props.subscription.CCName,
            CCExpiry: this.props.subscription.CCExpiry,
            CCCvc: this.props.subscription.CCCvc,
            CCIssuer: this.props.subscription.CCIssuer,
            CCZip: this.props.subscription.CCZip,
            Processed: this.props.subscription.Processed,
            Notes: this.props.subscription.Notes,
        };
        this._readSubscription(this.props.userLoggedIn[0],this.props.id);
    }
    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }

_readSubscription(tenant,id){
    let tempURL = rest.subscription + '/' + id;
    fetch(tempURL, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'x-api-key': tenant.apiKey
        })
    })
        .then(response => response.json())
        .then(data => {
            //debugger;
            this.setState({
                RequestingTenantId: data.RequestingTenantId,
                EventType: data.EventType,
                Userid: data.Userid,
                Kioskid: data.Kioskid,
                Email:  data.Email,
                Company: data.Company,
                Fname: data.Fname,
                Lname: data.Lname,
                Address: data.Address,
                City: data.City,
                State: data.State,
                Country: data.Country,
                Postal: data.Postal,
                Phone: data.Phone,
                Role: data.Role,
                SubscriptionDate: data.SubscriptionDate,
                SubscriptionStatus: data.SubscriptionStatus,
                SubscriptionType: data.SubscriptionType,
                SubscriptionPrice: data.SubscriptionPrice,
                SubscriptionMultiShopCount: data.SubscriptionMultiShopCount,
                CustomerXRef: data.CustomerXRef,
                UserHash: data.UserHash,
                UserSalt: data.UserSalt,
                KioskHash: data.KioskHash,
                KioskSalt: data.KioskSalt,
                CCNumber: data.CCNumber,
                CCName: data.CCName,
                CCExpiry: data.CCExpiry,
                CCCvc: data.CCCvc,
                CCIssuer: data.CCIssuer,
                CCZip: data.CCZip,
                Processed: data.Processed,
                Notes: data.Notes
            });
            return (data);
        })
        .catch(error => console.error(error));

}


    successAlert(saved){
        //Setup the alert and use the context to route to the Subscriptions once record is saved.
        if(saved) {
            this.setState({
                alert: (
                    <SweetAlert
                        success
                        title="Subscription event processed successfully!"
                        style={{display: "block"}}
                        onConfirm={() => this.context.router.history.push("/managesubscriptions")}
                        onCancel={() => this.context.router.history.push("/managesubscriptions")}
                        confirmBtnBsStyle="info"
                    >
                    </SweetAlert>
                )
            });
        }
        else
        {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Error processing this subscription event, Please try again!"
                        onConfirm={() => this.setState({alert: null})}
                        onCancel={() => this.setState({alert: null})}
                        confirmBtnBsStyle="danger"
                    >
                    </SweetAlert>
                )
            });
        }
    }

    //Based on the register event string we will collect the data we need and update or add a tenant as needed
    _grabUserInput() {
        var crypto = require('crypto');
        var subscriptionDate_s,subscriptionStatus_b;
        switch(this.state.EventType) {
            case "Register":
            case "Reactivate":
            case "Update_CC":
                subscriptionDate_s = "01/01/2090";
                subscriptionStatus_b = true;
                break;
            case "Cancel":
                subscriptionDate_s = "01/01/2000";
                subscriptionStatus_b = false;
                break;
        }
        //assign the Salt, generate the hash based on the password provided
        //grab fields based on mode
        return {
            id: this.props.id,
            RequestingTenantId: this.state.RequestingTenantId,
            EventType: this.state.EventType,
            Userid: this.state.Userid,
            Kioskid: this.state.Kioskid,
            Email:  this.state.Email,
            Company: this.state.Company,
            Fname: this.state.Fname,
            Lname: this.state.Lname,
            Address: this.state.Address,
            City: this.state.City,
            State: this.state.State,
            Country: this.state.Country,
            Postal: this.state.Postal,
            Phone: this.state.Phone,
            Role: "User",
            SubscriptionDate: subscriptionDate_s,
            SubscriptionStatus: subscriptionStatus_b,
            SubscriptionType: this.state.SubscriptionType,
            SubscriptionPrice: this.state.SubscriptionPrice,
            SubscriptionMultiShopCount: this.state.SubscriptionMultiShopCount,
            CCNumber: "",
            CCName: "",
            CCExpiry: "",
            CCCvc: "",
            CCIssuer: "",
            CCZip: "",
            CustomerXRef: document.getElementById('CustomerXRef').value,
            UserHash: this.state.UserHash,
            UserSalt: this.state.UserSalt,
            KioskHash: this.state.KioskHash,
            KioskSalt: this.state.KioskSalt,
            Processed: true,
            Notes: this.state.Notes
        };
    }

    _warningWithConfirmMessage(event) {
        event.preventDefault();
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{display: "block", marginTop: "-100px"}}
                    title="Are you sure you want to process this event?"
                    onConfirm={() => this._processSubscriptionEvent()}
                    onCancel={() => this._hideAlert()}
                    confirmBtnBsStyle="info"
                    cancelBtnBsStyle="danger"
                    confirmBtnText="Yes, process it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    Make sure you have added/updated this tenant in our billing system first, once processed ALL CC
                    information will be DELETED!
                </SweetAlert>
            )
        });
    }

    async _processSubscriptionEvent(){
        //Check to see if the passwords match
            //the save customer Thunk and pass it the current form values
            let userInput = this._grabUserInput();
            //Update the subscription and tenant record if needed, depending on subscription event type.
            this.props.subscriptionActions.updateSubscription(this.props.userLoggedIn[0],userInput);
            //lets update the tenant database based on the event type
            //based on Event Type we need to use a different URL and method
            var tempURL,method_s,apikey_s;

            if(userInput.EventType === "Register") {
                tempURL = rest.tenants;
                method_s = 'POST';
                apikey_s = this.props.userLoggedIn[0].apiKey;
            }
            else {
                tempURL = rest.tenants + '/' + userInput.RequestingTenantId;
                method_s = 'PUT';
                apikey_s = this.props.userLoggedIn[0].apiKey;
            }
            //let tempURL = rest.tenants;
            await fetch(tempURL, {
                method: method_s,
                headers: new Headers({
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-api-key': apikey_s,
                }),
                body: JSON.stringify({
                    Userid: userInput.Userid,
                    Email: userInput.Email,
                    Company: userInput.Company,
                    Fname: userInput.Fname,
                    Lname: userInput.Lname,
                    Address: userInput.Address,
                    City: userInput.City,
                    State: userInput.State,
                    Country: userInput.Country,
                    Postal: userInput.Postal,
                    Phone: userInput.Phone,
                    SubscriptionDate: userInput.SubscriptionDate,
                    SubscriptionStatus: userInput.SubscriptionStatus,
                    SubscriptionType: userInput.SubscriptionType,
                    SubscriptionMultiShopCount: userInput.SubscriptionMultiShopCount,
                    SubscriptionPrice: userInput.SubscriptionPrice,
                    CustomerXRef: userInput.CustomerXRef,
                    Role: userInput.Role,
                    Hash: userInput.UserHash,
                    Salt: userInput.UserSalt
                }),
            })
                .then(response => response.json())
                .then(data => {
                    if(userInput.EventType === "Register") {
                        //Now lets get the tenant ID of the new tenant using the hash and id
                        fetch(rest.loginUser,{
                            method: 'POST',
                            body: JSON.stringify({
                                username: userInput.Userid,
                                hash: userInput.UserHash
                            }),
                            insecure:true,
                            headers: new Headers({
                                'Content-Type': 'application/json;charset=UTF-8',
                                'x-api-key' : rest.apiKey
                            })
                        })
                        .then(response => response.json())
                        .then(data => {
                            //ONLY add the Kiosk User if the Event Type is a registration

                            //Finally lets add the new Kiosk User to the Tenant Id we got from logging in
                            let tempURL = rest.kioskusers + '/' + data._id;
                            //Current Tenant record that we will need to update
                            //Update the main MongoDB record
                            fetch(tempURL, {
                                method: 'POST',
                                headers: new Headers({
                                    'Content-Type': 'application/json;charset=UTF-8',
                                    'x-api-key': this.props.userLoggedIn[0].apiKey
                                }),
                                body: JSON.stringify({
                                    Name: userInput.Fname + " " + userInput.Lname,
                                    Userid: userInput.Kioskid,
                                    Hash: userInput.KioskHash,
                                    Salt: userInput.KioskSalt
                                }),
                            })
                                .then(response => response.json())
                                .then(data => {
                                    //Now send them an email letting them know we have activated their account
                                    var message = '<html><body>';
                                    message = message + "<h3>Congratulations! Your account with Tattoo Release Online has been Activated!</h3><br><br>\n" +
                                        "We are pleased to notify you that we have completed the processing of your TRO account and you<br>\n" +
                                        "can now login via our website at <a href=\"https://consent.tattooreleaseonline.com\">Tattoo Release Online</a>.\n" +
                                        "Please make sure to use the Tenant Login<br> to access Tenant mode which is used for\n" +
                                        "configuration and reporting for your tenant.<br><br>\n" +
                                        "We also created a Kiosk User for you with the credentials that you provided when you signed up.<br>\n" +
                                        "Make sure to use the Kiosk Login option to login with your Kiosk credentials.\n" +
                                        "We recommend<br> that you use your Kiosk credentials when processing your consent forms keeping\n" +
                                        "your configuration<br> and customer information secure. You can contact us via our <a href=\"https://consent.tattooreleaseonline.com/#/contact\">Contact Us</a>\n" +
                                        "page with any questions or<br> issues you may have.<br><br>\n" +
                                        "\n" +
                                        "Cheers,<br><br>\n" +
                                        "\n" +
                                        "The TRO Team" +
                                        "</body></html>";
                                    fetch(rest.sendmail, {
                                        headers: new Headers({
                                            'Content-Type': 'application/json;charset=UTF-8',
                                            'x-api-key': rest.apiKey
                                        }),
                                        method: 'POST',

                                        body: JSON.stringify({
                                            to: userInput.Email,
                                            from: rest.email,
                                            subject: "TRO Account Activated!",
                                            message: message
                                        })
                                    })
                                        .then(response => response.json())
                                        .then(data => {
                                        })
                                        .catch(error => console.error(error));

                                }).catch(error => console.error(error));
                            });
                    }
                    //Since its not a registration, lets send an email to the customer letting them know we
                    //processed their subscription change request
                    else {
                        //Now send them an email letting them know we have activated their account
                        var message = '<html><body>';
                        message = message + "<h3>Your Subscription was updated successfully!</h3><br><br>\n" +
                            "We are pleased to notify you that we have completed the processing of your recent subscription change request.<br>\n" +
                            "Whether you updated your Credit Card information, reactivated your subscription or canceled your existing subscription, in\n" +
                            "any case we have completed your request!<br><br>\n" +
                            "\n" +
                            "Cheers,<br><br>\n" +
                            "\n" +
                            "The TRO Team" +
                            "</body></html>";
                        fetch(rest.sendmail, {
                            headers: new Headers({
                                'Content-Type': 'application/json;charset=UTF-8',
                                'x-api-key': rest.apiKey
                            }),
                            method: 'POST',

                            body: JSON.stringify({
                                to: userInput.Email,
                                from: rest.email,
                                subject: "TRO Subscription Change Request Processed!",
                                message: message
                            })
                        })
                            .then(response => response.json())
                            .then(data => {
                            })
                            .catch(error => console.error(error));
                    }

                    this.successAlert(true);
                })
                .catch(error => console.error(error));
    }

    _hideAlert() {
        this.setState({
            alert: null
        });
    }


    render() {
        //debugger;
        if (this.props.userLoggedIn[0].role === "Admin") {
            switch(this.state.EventType) {
                case "Register":
                case "Update_CC":
                case "Cancel":
                case "Reactivate":
                    var processingOptions = (
                        <Card
                            content={
                                <div>
                                    <legend>Processing Options</legend>
                                    <Row>
                                        {(!this.state.Processed) ? (
                                            <Col md={2} xs={2} mdOffset={4}>
                                                <Button bsStyle="info" pullRight fill wd
                                                        onClick={this._warningWithConfirmMessage}>
                                                    Process Event
                                                </Button>
                                            </Col>
                                            ) : (
                                            <Col md={2} xs={2} mdOffset={4}>
                                                <Button bsStyle="info" pullRight fill wd
                                                    onClick={this._warningWithConfirmMessage}
                                                    disabled={true}>
                                                Process Event
                                                </Button>
                                            </Col>
                                            )}
                                        <Col md={2} xs={2} >
                                            <Button bsStyle="info" pullRight fill wd onClick={async () => {
                                                let tURL = "/managesubscriptions";
                                                await this.context.router.history.push(tURL);
                                            }}>
                                                Cancel
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        /> );
                    break;
                default:
                    break;
            }

            return (
                <div className="main-content" style={{backgroundImage: "url("+require("../../assets/img/matrix.jpg")+")", backgroundSize: "cover",
                    backgroundPosition: "center center"}}>
                    <Grid fluid>
                        <Card
                            content={
                                <div>
                                    <legend>Subscription Event Information</legend>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Event Type </ControlLabel>
                                                <FormControl
                                                    id="EventType"
                                                    type="text"
                                                    name="EventType"
                                                    placeholder=""
                                                    value={this.state.EventType}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} >
                                            <FormGroup>
                                                <ControlLabel>Status </ControlLabel>
                                                {(this.state.Processed) ? (
                                                    <FormControl
                                                        id="Status"
                                                        type="text"
                                                        name="Status"
                                                        placeholder=""
                                                        value="Processed"
                                                        disabled={true}
                                                    />
                                                ) : (
                                                    <FormControl
                                                        id="Status"
                                                        type="text"
                                                        name="Status"
                                                        placeholder=""
                                                        value="Not Processed"
                                                        disabled={true}
                                                    />
                                                    )}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>First Name </ControlLabel>
                                                <FormControl
                                                    id="Fname"
                                                    type="text"
                                                    name="first_name"
                                                    placeholder="ex: Mike"
                                                    value={this.state.Fname}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <ControlLabel>Last Name </ControlLabel>
                                                <FormControl
                                                    id="Lname"
                                                    type="text"
                                                    name="last_name"
                                                    placeholder="ex: Andrew"
                                                    value={this.state.Lname}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Company </ControlLabel>
                                                <FormControl
                                                    id="Company"
                                                    type="text"
                                                    name="company"
                                                    placeholder="ex: My Sweet Company Name"
                                                    value={this.state.Company}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <ControlLabel>Address </ControlLabel>
                                                <FormControl
                                                    id="Address"
                                                    type="text"
                                                    name="address"
                                                    placeholder="ex: 8675 County Road 309"
                                                    value={this.state.Address}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>City </ControlLabel>
                                                <FormControl
                                                    id="City"
                                                    type="text"
                                                    name="city"
                                                    placeholder="ex: Elizabeth"
                                                    value={this.state.City}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup>
                                                <ControlLabel>State </ControlLabel>
                                                <FormControl
                                                    id="State"
                                                    type="text"
                                                    name="state"
                                                    placeholder="ex: Colorado"
                                                    value={this.state.State}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={4}>
                                            <FormGroup>
                                                <ControlLabel>Postal Code </ControlLabel>
                                                <FormControl
                                                    id="Postal"
                                                    type="text"
                                                    name="postal"
                                                    placeholder="ex: 80107"
                                                    value={this.state.Postal}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Country </ControlLabel>
                                                <FormControl
                                                    id="Country"
                                                    type="text"
                                                    name="country"
                                                    placeholder="ex: USA"
                                                    value={this.state.Country}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={5}>
                                            <FormGroup>
                                                <ControlLabel>
                                                    Email
                                                </ControlLabel>
                                                <FormControl
                                                    id="Email"
                                                    type="email"
                                                    name="email"
                                                    value={this.state.Email}
                                                    placeholder="ex: dd@disney.com"
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Phone Number </ControlLabel>
                                                <FormControl
                                                    id="Phone"
                                                    type="text"
                                                    name="Phone"
                                                    placeholder="ex: 303-867-5309"
                                                    value={this.state.Phone}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Subscription Type </ControlLabel>
                                                <FormControl
                                                    id="SubscriptionType"
                                                    type="text"
                                                    name="SubscriptionType"
                                                    placeholder="ex: Monthly"
                                                    value={this.state.SubscriptionType}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <ControlLabel>Multi-Shop Count: </ControlLabel>
                                                <FormControl
                                                    id="MultiShopCount"
                                                    type="text"
                                                    name="multishopcount"
                                                    placeholder="ex: 0"
                                                    value={this.state.SubscriptionMultiShopCount}
                                                    disabled={true}
                                                    //onChange={event => this.setState({SubscriptionMultiShopCount: event.target.value})}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <ControlLabel>Subscription Price (USD): </ControlLabel>
                                                <FormControl
                                                    id="SubscriptionPrice"
                                                    type="number"
                                                    name="subscriptionprice"
                                                    placeholder="99"
                                                    value={this.state.SubscriptionPrice}
                                                    disabled={true}
                                                    //onChange={event => this.setState({SubscriptionPrice: event.target.value})}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Subscription End Date </ControlLabel>
                                                <FormControl
                                                    id="SubscriptionDate"
                                                    type="text"
                                                    name="SubscriptionDate"
                                                    placeholder="ex: 01/01/2020"
                                                    value={this.state.SubscriptionDate}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} >
                                            <FormGroup>
                                                <ControlLabel>Customer External Reference </ControlLabel>
                                                <FormControl
                                                    id="CustomerXRef"
                                                    type="text"
                                                    name="CustomerXRef"
                                                    placeholder="ex: CUST99999"
                                                    value={this.state.CustomerXRef}
                                                    onChange={event => this.setState({CustomerXRef: event.target.value})}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        />
                        <Card
                            content={
                                <div>
                                    <legend>Credit Card Information</legend>
                                    <Row>
                                        <Col md={2} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Card Type </ControlLabel>
                                                <FormControl
                                                    id="CCIssuer"
                                                    type="text"
                                                    name="CCIssuer"
                                                    placeholder=""
                                                    value={this.state.CCIssuer}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={3} >
                                            <FormGroup>
                                                <ControlLabel>Card Number </ControlLabel>
                                                <FormControl
                                                    id="CCCard"
                                                    type="text"
                                                    name="CCNumber"
                                                    placeholder=""
                                                    value={this.state.CCNumber}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <ControlLabel>Expiration </ControlLabel>
                                                <FormControl
                                                    id="CCExpiry"
                                                    type="text"
                                                    name="CCExpiry"
                                                    placeholder=""
                                                    value={this.state.CCExpiry}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2}>
                                            <FormGroup>
                                                <ControlLabel>CVC </ControlLabel>
                                                <FormControl
                                                    id="CCCvc"
                                                    type="text"
                                                    name="CCCvc"
                                                    placeholder=""
                                                    value={this.state.CCCvc}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Name on Card</ControlLabel>
                                                <FormControl
                                                    id="CCName"
                                                    type="text"
                                                    name="CCName"
                                                    placeholder=""
                                                    value={this.state.CCName}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={2} >
                                            <FormGroup>
                                                <ControlLabel>Card Zip Code</ControlLabel>
                                                <FormControl
                                                    id="CCZip"
                                                    type="text"
                                                    name="CCZip"
                                                    placeholder=""
                                                    value={this.state.CCZip}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        />
                        {processingOptions}
                        {this.state.alert}
                    </Grid>
                </div>
            );
        }
        else {
            this.context.router.history.push("/pages/login-page");
            return(null);
        }
    }
}

SubscriptionForm.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    subscription: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;  //from editsubscription/:id
    return {
        userLoggedIn: state.userLoggedIn,
        subscription: state.subscription,
        id: id
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionForm);




// WEBPACK FOOTER //
// ./src/views/Forms/EditSubscription.jsx